import { TicketService } from "../../services/ticket-service";
import { action, makeAutoObservable, observable, runInAction } from 'mobx';
import { message } from 'antd';
import Subjects from "../../models/subjects";

export default class TicketBar {

    ticketService: TicketService;

    @observable
    id?: number | null;

    @observable
    percent: number;

    constructor(subject: Subjects) {

        this.ticketService = new TicketService(subject);

        this.id = null;
        this.percent = 0;
        makeAutoObservable(this);
    }

    @action
    loadCurrent(): void {

        try {
            this.ticketService.loadCurrent(
                data => {
                    if (data?.id) {
                        runInAction(() => {
                            this.id = data['id'];
                            this.percent = Math.ceil(data['currentTaskCount'] / data['taskCount'] * 100);
                        });
                    }
                }
            );
        } catch (error) {
            runInAction(() => { message.error(error) });
        }
    }

    @action
    update(id: number | null | undefined, currentTaskCount: number, taskCount: number): void {
        this.id = id;
        this.percent = Math.ceil(currentTaskCount / taskCount * 100);
    }
}